import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { on } from '@ember/modifier';

import joinClasses from 'webapp/helpers/join-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface SectionWithTogglerComponentInterface {
	Args: {
		title: string;
		isOpen: boolean;
		tooltip?: string;
		skip?: boolean;
		isSectionTogglerHidden?: boolean;
		toggle?: () => void;
	};
	Blocks: { default: [] }; // this is needed for yield
}

const SectionWithTogglerComponent: TOC<SectionWithTogglerComponentInterface> = <template>
	{{#if @skip}}
		{{yield}}
	{{else}}
		<div
			class={{joinClasses
				(array
					"section-with-toggler"
					(if @isOpen "section-with-toggler--open")
					(if @isSectionTogglerHidden "section-with-toggler--hidden")
				)
			}}
		>
			<div class="section-toggler">
				<div class="section-toggler-inner">
					{{#if @toggle}}
						<a role="button" {{on "click" @toggle}}>
							{{#if @isOpen}}
								<CommonUiIconComponent @name="ChevronUp" @size="sm" />
							{{else}}
								<CommonUiIconComponent @name="ChevronDown" @size="sm" />
							{{/if}}
							{{@title}}
						</a>
					{{else}}
						{{@title}}
					{{/if}}

					{{#if @tooltip}}
						<ToolTipWithIconComponent @text={{@tooltip}} @maxWidth={{250}} />
					{{/if}}
				</div>
			</div>

			<div class="section-content">
				{{yield}}
			</div>
		</div>
	{{/if}}
</template>;

export default SectionWithTogglerComponent;
